module.exports = __webpack_public_path__ + "img/m-banner-xzdvxwdm-th-TH.9349687d.jpg";